import { render } from "./TicketsTableMobile.vue?vue&type=template&id=689d0173&scoped=true&ts=true"
import script from "./TicketsTableMobile.vue?vue&type=script&lang=ts"
export * from "./TicketsTableMobile.vue?vue&type=script&lang=ts"

import "./TicketsTableMobile.vue?vue&type=style&index=0&id=689d0173&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689d0173"]])

export default __exports__